import React from "react";
import Select from "react-select";
import { Button } from "@wac-ui-dashboard/wac_component_library";
import useImageCertification from "../useImageCertification";

const Filter = () => {
  const {
    imageCertificationState,
    itemTypeList,
    handleItemTypeChange,
    handleCertificateNumberChange,
    handleCertificateNumberSubmit,
    handleClearClick,
  } = useImageCertification();

  return (
    <div>
      <div className="input-wrap pro-mb-4">
        <label htmlFor="cert_number" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Certificate Number
        </label>
        <input
          id="cert_number"
          type="text"
          className="pro-input lg"
          placeholder="Enter Certificate Number"
          value={imageCertificationState?.tempCertificateNumber}
          onChange={handleCertificateNumberChange}
        />
      </div>
      <div className="input-wrap pro-mb-4">
        <label htmlFor="item_type_filter" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Item Type
        </label>
        <Select
          id="item_type_filter"
          name="item_type_filter"
          placeholder="Select Item Type"
          isClearable
          isMulti
          className="pro-input lg"
          classNamePrefix="pro-input"
          options={itemTypeList?.data?.item_types || []}
          getOptionLabel={(option) => option?.name}
          getOptionValue={(option) => option?._id}
          value={itemTypeList?.data?.item_types?.filter((m) =>
            imageCertificationState?.tempSelectedItemType?.includes(m._id)
          )}
          onChange={handleItemTypeChange}
          menuPlacement="auto"
        />
      </div>
      <div className="col-12 pro-d-flex pro-justify-end offcanvas-footer-sticky-btn">
        <Button className="pro-btn-link lg pro-px-5" onClick={handleClearClick}>
          Reset
        </Button>
        <Button
          className="pro-btn-primary lg pro-ms-3"
          type="button"
          onClick={handleCertificateNumberSubmit}
        >
          Apply
        </Button>
      </div>
    </div>
  );
};

export default Filter;
